//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PchPurchaseInvoiceListView from "@/views/Purchase/PchPurchaseInvoice/list"

//
export default {
  path: "pch_purchase_invoice",
  component: ModuleLayout,
  children: [
    {
      name: "pch-purchase-invoice-list",
      path: "",
      component: PchPurchaseInvoiceListView,
    },
  ],
  meta: {
    title: "Facturas de compra"
  },
}